import { filter, ignoreElements, map } from "rxjs/operators";
import { landingPageMessageHandler } from "../landing-page/landingPageMessageHandler";
import { TypeActionModal } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
export var epicGoogleTagMangerShopVisit = function (action$, state$, deps) {
    return action$.pipe(filter(function (action) {
        return action.type === TypeActionModal.Open && action.modalId === IdModal.Shop;
    }), map(function () {
        landingPageMessageHandler.onShopVisit();
    }), ignoreElements());
};



//////////////////
// WEBPACK FOOTER
// ./src/features/google-tag-manager/epicGoogleTagMangerShopVisit.ts
// module id = 1891
// module chunks = 3